import colors, { TypeColorNames } from "../../../theme/colors";

export default function EyeIcon({ size, color }: { size?: string, color?: TypeColorNames }) {
  return (
    <svg
      width={size || "12"}
      height={size || "12"}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <path
        d="M0.667487 6.62803C0.444173 6.23908 0.444171 5.76099 0.667483 5.37204C1.84248 3.32549 3.72189 2 5.8399 2C7.95789 2 9.83729 3.32547 11.0123 5.37199C11.2356 5.76094 11.2356 6.23903 11.0123 6.62799C9.83729 8.67454 7.95788 10 5.83988 10C3.72189 10 1.84248 8.67455 0.667487 6.62803Z"
        stroke={color ? colors[color] : colors['title']}
      />
      <circle cx="5.83984" cy="6" r="1.5" stroke={color ? colors[color] : colors['title']} />
    </svg>
  );
}
